import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import PushNotificationBootstrap from "./components/notifications/PushNotificationBootstrap";
import NotificationToast from "./components/notifications/NotificationToast";
import { AuthProvider } from "./context/AuthContext";
import { ControlPanelProvider } from "./context/ControlPanelContext";
import "./styles/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ControlPanelProvider>
          <PushNotificationBootstrap />
          <NotificationToast />
          <App />
        </ControlPanelProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ""}/offline-sw.js`).catch(() => {});
  });
}